import axios from 'axios';

document.addEventListener('alpine:init', () => {
  Alpine.store('favorites', {
    shareLink: '',
    isShareLinkVisible: false,

    async addFavorite(id) {
      await this.handleFavoriteClick('add', id);
    },

    async removeFavorite(id) {
      await this.handleFavoriteClick('delete', id);
    },

    async handleFavoriteClick(action, id) {
      await axios.post(`/api/favorites/${action}?id=${id}`);
      this.$dispatch('favorite-updated', { id, action });
    },

    async createLink() {
      const response = await axios.post("/api/favorites/create-link?url=" + location.href);
      this.shareLink = response.data.link;
      this.isShareLinkVisible = true;
      await navigator.clipboard.writeText(this.shareLink);
    },

    copyLink() {
      navigator.clipboard.writeText(this.shareLink);
    },

    async share() {
      try {
        // First get the share link
        const response = await axios.post("/api/favorites/create-link?url=" + location.href);
        const shareLink = response.data.link;

        // Check if Web Share API is available
        if (navigator.share) {
          await navigator.share({
            title: document.title,
            text: 'Check out this link',
            url: shareLink
          });
        } else {
          // Fallback to the old method if Web Share API is not available
          this.shareLink = shareLink;
          this.isShareLinkVisible = true;
          await navigator.clipboard.writeText(this.shareLink);
        }
      } catch (error) {
        console.error('Error sharing:', error);
      }
    }
  });
});